<template>
  <div id="lockerStatus" v-loading.fullscreen.lock="pageLoading">
    <div class="main">
      <div class="group-list">
        <p class="title">
          {{ $t("SmartLocker.GroupListTitle") }}
        </p>
        <div class="filter-options">
          <p>{{ $t("SmartLocker.SmartLockerPosition") }}</p>
          <div class="group-buttons">
            <el-button
              v-for="(g, index) in ownerGroupList"
              :key="g.id+index || `all+${index}`"
              round
              :type="isActiveGroup(g) ? 'primary' : ''"
              @click="selectGroup(g)"
            >
              {{ g.Name }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="ownerGroupList.length > 1 && selectedGroupId !== ''" class="available-buildings">
        <p>{{ $t("SmartLocker.SmartLockerAvailableBuilding") }} : {{ selectedGroupTags }}</p>
      </div>
      <template v-if="smartLockerCounterData.length!==0">
        <div class="remaining-count-hint">
          {{ selectedGroupPositionName }}{{ $t("SmartLocker.RemainingCount") }}
        </div>
        <smartLockerCount :locker-size-counter="lockerSizeCounter" />
      </template>
      <smartLockerSelection
        :smart-locker-counter-data="smartLockerCounterData"
        :now-smart-locker-index="nowSmartLockerIndex"
        :selected-group-id="selectedGroupId"
        @controlSmartLocker="controlSmartLocker"
      />
      <div class="list_frame">
        <el-table
          ref="multipleTable"
          v-loading="loadingList"
          tooltip-effect="dark"
          :data="showSmartLockerStoreData"
          style="width: 100%"
          :span-method="objectSpanMethod"
          :cell-class-name="cellClassName"
          @cell-mouse-enter="cellMouseEnter"
          @cell-mouse-leave="cellMouseLeave"
          @sort-change="sortChange"
        >
          <!-- 櫃位編號 -->
          <el-table-column
            prop="CounterName"
            :label="$t('SmartLocker.LockerStatusLabelCubbyName')"
            width="130"
            sortable
            :sort-method="sortCounterName"
          >
            <template slot-scope="scope">
              {{ scope.row.CounterName }}
            </template>
          </el-table-column>
          <!-- 櫃位狀態 -->
          <el-table-column
            prop="CounterStatus"
            :label="$t('SmartLocker.LockerStatusLabelCubbyStatus')"
            width="130"
            sortable
            :sort-method="sortCounterStatus"
          >
            <template slot-scope="scope">
              <span
                :class="{
                  'disabled-font': !scope.row.Enable,
                  'used-font': scope.row.Used,
                  'not-use-font': !scope.row.Used
                }"
              >
                {{ scope.row.Enable ? scope.row.Used ? $t('SmartLocker.Use') : $t('SmartLocker.NotUse') : $t('SmartLocker.Disabled') }}
              </span>
            </template>
          </el-table-column>
          <!-- 郵件編號 -->
          <el-table-column
            prop="PostalDetailSerialNum"
            :label="$t('SmartLocker.LockerStatusLabelSerialNum')"
            width="130"
          >
            <template slot-scope="scope">
              {{ scope.row.PostalDetailSerialNum || '' }}
            </template>
          </el-table-column>
          <!-- 郵件種類 -->
          <el-table-column
            prop="PostalTypeName"
            :label="$t('SmartLocker.LockerStatusLabelPostalTypeName')"
            width="130"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.PostalTypeName }}</div>
            </template>
          </el-table-column>
          <!-- 收件戶別/收件人 -->
          <el-table-column
            prop="PostalName"
            :label="$t('SmartLocker.LockerStatusLabelPostalName')"
            sortable
            :sort-method="sortPostalName"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.TabletNote }}</div>
              <div>{{ scope.row.UserName }}</div>
            </template>
          </el-table-column>
          <!-- 管理人員 -->
          <el-table-column
            prop="AdminName"
            :label="$t('SmartLocker.LockerStatusLabelAdminName')"
          >
            <template slot-scope="scope">
              <div class="locker-photo-name" @click="handleDisplayLockerUserPhoto(scope.row)">
                {{ scope.row.AdminName }}
                <i v-if="scope.row.Enable && scope.row.Used" class="icon-images" />
              </div>
            </template>
          </el-table-column>
          <!-- 入櫃日期 -->
          <el-table-column
            prop="StoreAt"
            :label="$t('SmartLocker.LockerStatusLabelStoreAt')"
            width="130"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.StoreAt ? $newFormatDate(scope.row.StoreAt, 'yyyy-MM-dd') : '' }}</div>
              <div>{{ scope.row.StoreAt ? $newFormatDate(scope.row.StoreAt, 'HH:mm') : '' }}</div>
            </template>
          </el-table-column>
          <!-- 累積入櫃日期 -->
          <el-table-column
            prop="AccumulatedDays"
            :label="$t('SmartLocker.LockerStatusLabelDaysCount')"
            width="140"
            sortable
            :sort-method="sortAccumulatedDays"
          >
            <template slot-scope="scope">
              {{ scope.row.Used ? scope.row.AccumulatedDays : '' }}
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            prop="Action"
            :label="$t('SmartLocker.LockerStatusLabelActionCount')"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.Used"
                size="mini"
                plain
                @click.stop="notificationAgain(scope.row)"
              >
                {{ $t('SmartLocker.NotificationAgain') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :title="$t('SmartLocker.LockerPersonnelPhoto')"
      :visible="isDialogVisible"
      class="locker-photo-dialog"
      :show-close="true"
      width="30%"
      @close="closeDialog"
    >
      <img v-for="image in imageUrlList" :key="image.Path" :src="image.Path" alt="入櫃人員照片" style="width: 100%;" />
      <div v-if="imageUrlList.length === 0">
        <img src="" alt="查無檔案" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import smartLockerSelection from './components/smartLockerSelection.vue'
import smartLockerCount from './components/smartLockerCount.vue'
import { apiSmartLocker, mapiSmartLocker } from '@/api/SmartLocker.js'
export default {
  components: {
    smartLockerSelection,
    smartLockerCount
  },
  data () {
    return {
      pageLoading: false,
      loadingList: false,
      lockerSizeCounter: {},
      nowSmartLockerIndex: 0,
      smartLockerCounterData: [],
      smartLockerStoreData: [],
      sortOrder: '',
      sortColName: '',
      hoverGroupId: '',
      isDialogVisible: false,
      imageUrlList: [],
      selectedGroupId: null
    }
  },
  computed: {
    ...mapState('smartLocker', ['ownerGroupList']),
    showSmartLockerStoreData () {
      if (this.smartLockerStoreData.length >= this.nowSmartLockerIndex) {
        return this.smartLockerStoreData[this.nowSmartLockerIndex - 1]
      }
      return []
    },
    sortedData () {
      let sortedData = JSON.parse(JSON.stringify(this.showSmartLockerStoreData))
      switch (this.sortColName) {
      case 'CounterName':
        sortedData = sortedData.sort(this.sortCounterName)
        if (this.sortOrder === 'descending') sortedData = sortedData.reverse()
        break
      case 'CounterStatus':
        sortedData = sortedData.sort(this.sortCounterStatus)
        if (this.sortOrder === 'descending') sortedData = sortedData.reverse()
        break
      case 'PostalName':
        sortedData = sortedData.sort(this.sortPostalName)
        if (this.sortOrder === 'descending') sortedData = sortedData.reverse()
        break
      case 'AccumulatedDays':
        sortedData = sortedData.sort(this.sortAccumulatedDays)
        if (this.sortOrder === 'descending') sortedData = sortedData.reverse()
        break
      }
      sortedData.forEach((item, index) => {
        if (item.CounterId === sortedData[index + 1]?.CounterId && item.CounterId !== sortedData[index - 1]?.CounterId) { // 合併的第一個
          item.group = item.PostalDetailId
        } else if (item.CounterId === sortedData[index - 1]?.CounterId) {
          item.group = sortedData[index - 1].group
        }
      })
      return sortedData
    },
    selectedGroupPositionName () {
      // 櫃體位置名稱
      if (this.selectedGroupId === '' || this.ownerGroupList.length === 1) return '社區'
      const group = this.ownerGroupList.find(g => g.Id === this.selectedGroupId)
      return group ? group.Name : ''
    },
    selectedGroupTags () {
      // 櫃體位置可用棟別
      const group = this.ownerGroupList.find(g => g.Id === this.selectedGroupId)
      return (group?.Tags || [])
        .filter(t => t != null && String(t).trim() !== '')// 去掉空值
        .map(t => String(t).trim())
        .join('、')
    }
  },
  watch: {
    ownerGroupList: {
      handler (newList, oldList) {
        // 如果是「全部」→ 任何群組名稱有變都重抓
        if (this.selectedGroupId === '') {
          this.getSmartLockerData()
          return
        }

        // 如果是目前選中的群組 → 名稱有改就重抓
        const oldGroup = oldList?.find(g => g.Id === this.selectedGroupId)
        const newGroup = newList?.find(g => g.Id === this.selectedGroupId)

        if (oldGroup && newGroup && oldGroup.Name !== newGroup.Name) {
          this.getSmartLockerData()
        }
      },
      deep: true
    }
  },
  async created () {
    await this.fetchGroupList()
    this.ensureDefaultGroup()
  },

  methods: {
    ...mapActions('smartLocker', ['fetchGroupList']),
    isActiveGroup (g) {
      return g.Id === this.selectedGroupId
    },
    selectGroup (g) {
      this.selectedGroupId = g.Id
      this.getSmartLockerData()
    },
    ensureDefaultGroup () {
      const btns = this.ownerGroupList
      if (!btns.length) {
        this.selectedGroupId = null
        this.nowSmartLockerIndex = this.smartLockerCounterData.length ? 1 : 0
        return
      }

      // case 1：只有一個群組 → 直接選它
      if (btns.length === 1) {
        this.selectedGroupId = btns[0].Id
        this.selectGroup(btns[0])
        return
      }

      // case 2：有多個 → 選 sort 最小的 (groupButtons[0])
      this.selectedGroupId = btns[0].Id
      this.selectGroup(btns[0])
    },
    async getSmartLockerData () {
      this.pageLoading = true
      try {
        // 🔹 組出要帶給 API 的參數（如果有選擇櫃體位置才加上）
        const query = {}
        if (this.selectedGroupId) {
          query.OwnerGroupId = this.selectedGroupId
        }

        // 🔹 傳參數給 API
        const res = await mapiSmartLocker.GetCounterScenario(query)
        if (res?.data?.Data) {
          this.smartLockerCounterData = res.data.Data.SmartLockerCounterDescriptionList || []
          const shapeState = {} // { [shapeName]: { total: number, available: number } }
          this.smartLockerStoreData = []
          if (this.smartLockerCounterData.length === 0) {
            this.nowSmartLockerIndex = 0
            this.smartLockerStoreData = []
            this.lockerSizeCounter = {}
            this.pageLoading = false
            return
          }
          this.smartLockerCounterData.forEach((smartLocker, index) => {
            const smartLockerID = smartLocker.SmartLockerId
            this.smartLockerStoreData[index] = res.data.Data.CounterContentList.filter((smartLockerStore) => smartLockerStore.SmartLockerId === smartLockerID && !smartLockerStore.IsComputer)
            smartLocker.CounterShapeDescriptionListGroupList.forEach((row) => {
              row.forEach((col) => {
                col.heightPercent = this.setTotalHeight(row, col)
                col.CounterShapeDescriptionList.forEach((counter) => {
                  counter.widthPercent = this.setTotalWidth(col.CounterShapeDescriptionList, counter)
                  if (counter.IsComputer) return
                  const shape = counter.ShapeName.trim()
                  if (!shapeState[shape]) {
                    shapeState[shape] = { total: 0, available: 0 }
                  }
                  shapeState[shape].total++
                  if (counter.Enable && !counter.Used) {
                    shapeState[shape].available += 1
                  }
                })
              })
            })
          })
          this.lockerSizeCounter = shapeState
          if (this.smartLockerCounterData.length > 0) this.nowSmartLockerIndex = 1
        }
      } catch (e) {
        console.log(e)
      }
      this.pageLoading = false
    },
    setTotalWidth (col, counter) {
      const totalWidth = col.reduce((a, b) => { return a + b.Width }, 0)
      const counterWidth = (counter.Width / totalWidth) * 100
      return `${counterWidth}%`
    },
    setTotalHeight (row, col) {
      let totalHeight = 0
      row.forEach((item) => {
        totalHeight += item.CounterShapeDescriptionList[0].Height
      })
      const colHeight = (col.CounterShapeDescriptionList[0].Height / totalHeight) * 100
      return `calc(${colHeight}% - 4px)`
    },
    controlSmartLocker (addIndex) {
      this.nowSmartLockerIndex += addIndex
    },
    notificationAgain (data) {
      this.$confirm(this.$t('SmartLocker.CheckNotification'), '', {
        confirmButtonText: this.$t('General.Confirm'),
        cancelButtonText: this.$t('General.Cancel')
      }).then(async () => {
        try {
          const counterId = data.CounterId
          const postalDetailIds = this.showSmartLockerStoreData.filter(item => item.CounterId === counterId).map(item => item.PostalDetailId)
          const requestData = {
            TabletId: data.TabletId,
            TabletNote: data.TabletNote,
            PostalDetailIds: postalDetailIds
          }
          await apiSmartLocker.PostRemind(requestData)
          this.$message({
            message: this.$t('SmartLocker.NotificationSuccess'),
            type: 'success'
          })
        } catch (e) {
          console.log(e)
        }
      }).catch(() => {
      })
    },
    sortCounterName (a, b) {
      if (a.CounterName > b.CounterName) return 1
      else if (a.CounterName < b.CounterName) return -1
      return 0
    },
    sortCounterStatus (a, b) {
      if (a.Enable && !b.Enable) return 1
      if (!a.Enable && b.Enable) return -1
      if (a.Used && !b.Used) return 1
      if (!a.Used && b.Used) return -1
      return this.sortCounterName(a, b)
    },
    sortPostalName (a, b) {
      if (`${a.TabletNote}` > `${b.TabletNote}`) return 1
      if (`${a.TabletNote}` < `${b.TabletNote}`) return -1
      return this.sortCounterName(a, b)
    },
    sortAccumulatedDays (a, b) {
      if (a.Used && !b.Used) return 1
      if (!a.Used && b.Used) return -1
      return a.AccumulatedDays - b.AccumulatedDays === 0 ? this.sortCounterName(a, b) : a.AccumulatedDays - b.AccumulatedDays
    },
    objectSpanMethod ({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 8) {
        let rowspan = 1
        for (let i = rowIndex + 1; i < this.sortedData.length; i++) {
          if (row.CounterId === this.sortedData[i]?.CounterId) {
            rowspan++
          } else break
        }
        if (rowspan > 1 && row.CounterId !== this.sortedData[rowIndex - 1]?.CounterId) {
          return {
            rowspan,
            colspan: 1
          }
        } else if (row.CounterId === this.sortedData[rowIndex - 1]?.CounterId) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    cellClassName ({ row, column, rowIndex }) {
      let className = ''
      if (column.property !== 'CounterName') className = `not-border ${className}`
      if (this.sortedData[rowIndex].group === this.hoverGroupId && this.hoverGroupId !== '') {
        className = `hover-col ${className}`
        if (column.property === 'CounterName') className = `border ${className}`
      }
      return className
    },
    cellMouseEnter (row) {
      const postalDetailId = row.PostalDetailId
      const data = this.sortedData.find((item) => item.PostalDetailId === postalDetailId)
      this.hoverGroupId = data.group || ''
    },
    cellMouseLeave () {
      this.hoverGroupId = ''
    },
    sortChange (val) {
      this.sortOrder = val.order
      if (this.sortOrder === null) this.sortColName = ''
      else this.sortColName = val.prop
    },
    async handleDisplayLockerUserPhoto (postal) {
      try {
        const query = {
          PostalDetailId: postal.PostalDetailId
        }
        const res = await apiSmartLocker.GetApplyStorageRecordImage(query)
        this.imageUrlList = res.data.Data.RecordImageList.filter(image => image.StatusId === 2)
      } catch (e) {
        console.log(e)
      }
      this.isDialogVisible = true
    },
    closeDialog () {
      this.isDialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .used-font {
  color: $mainFontColor;
}
::v-deep .not-use-font {
  color: $mainColor;
}
::v-deep .disabled-font {
  color: $dangerColor;
}
::v-deep .used-block {
  background-color: $bgDark1;
  color: $mainFontColor;
}
::v-deep .not-use-block {
  background-color: $mainColor;
  color: $white;
}
::v-deep .disabled-block {
  background-color: $dangerColor;
  color: $white;
}
#lockerStatus {
  text-align: center;
  padding: 20px 0 10px;
  height: 100%;
  ::v-deep .el-table {
    margin-top: 16px;
    @include basicTable;
  }
  .group-list {
    text-align: left;
    margin-bottom: 12px;
    background-color: $bgDarkBg;
    padding: 16px;

    .title{
      font-size: map-get($fontSize, medium);
      font-weight: bold;
      margin-bottom: 16px;
    }

    .filter-options{
      display: flex;
      align-items: center;
      p {
        font-size: map-get($fontSize, medium);
        margin-right: 12px;
      }
    }
  }
  .available-buildings {
    text-align: left;
    margin-bottom: 12px;
    font-size: map-get($fontSize, medium);
    background-color: $defaultColorHover;
    padding: 16px;
  }
  .remaining-count-hint {
    text-align: left;
    margin-bottom: 12px;
    font-size: map-get($fontSize, large);
    font-weight: bold;
  }
  .locker-photo-name {
    cursor: pointer;
    display: flex;
    align-items: center;
    & > i {
      margin-left: 5px;
    }
  }
}
.locker-photo-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;
    text-align: left;
    .title {
      margin-bottom: 16px;
      font-weight: 700;
      font-size: 20px;
    }
    .cancel-reason-type-select {
      margin-bottom: 24px;
    }
    .cancel-reason-info {
      margin-bottom: 32px;
    }
    .footer {
      text-align: center;
    }
  }
}
</style>
